


















































































































































































































































































































































import { mapMutations, mapGetters, mapState } from 'vuex'
import CTable from '~/components/shared/configurable/table/CTable.vue'
import AutoTouchService from '~/services/auto-touch/AutoTouchService'
import SnackbarService from '~/services/snackbar/SnackbarService'
import { format } from '~/utils/date'
import { deepJsonCopy } from '~/utils/object'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { SET_AUTO_TOUCH_DATA_IN_SEARCH } from '~/store/modules/shared/classifieds/search/mutation-types'
import { SET_AUTO_TOUCH_DATA_IN_VIEW } from '~/store/modules/shared/classifieds/view/mutation-types'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import { UserType } from '~/models/user/types'
import { AutoTouchAvailability } from '~/models/auto-touch/types'
import SinglePromoRegisterPrompt from '~/components/car/classifieds/promote/SinglePromoRegisterPrompt.vue'
import { HttpStatus } from '~/constants/http'
import { handleError } from '~/utils/http'
import CTableRow from '~/components/shared/configurable/table/CTableRow.vue'
import CTableHead from '~/components/shared/configurable/table/CTableHead.vue'
import CTableHeadCell from '~/components/shared/configurable/table/CTableHeadCell.vue'
import CTableBody from '~/components/shared/configurable/table/CTableBody.vue'
import CTableDataCell from '~/components/shared/configurable/table/CTableDataCell.vue'
import { TranslateResult } from 'vue-i18n'
import CAutoTouchCheckbox from '~/components/shared/configurable/auto-touch/CAutoTouchCheckbox.vue'
import PaidCreditsFunctionalityBadge from '~/components/shared/badges/PaidCreditsFunctionalityBadge.vue'
import OneClickAutoTouchButton from '~/components/car/classifieds/promote/OneClickAutoTouchButton.vue'
import { AccessToggleName } from '~/models/user/access-toggles'
import { ciCalendar } from '~/icons/source/regular/calendar'
import { ciAngleLeft } from '~/icons/source/light/angle-left'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { defineComponent, vue3Set } from '~/utils/nuxt3-migration'
import { ciExclamationCircle } from '~/icons/source/solid/exclamation-circle'
import { ciRotate } from '~/icons/source/regular/rotate'

export default defineComponent({
  components: {
    CBadge,
    OneClickAutoTouchButton,
    PaidCreditsFunctionalityBadge,
    CTableDataCell,
    CTableBody,
    CTableHeadCell,
    CTableHead,
    CTableRow,
    CTable,
    CAutoTouchCheckbox,
    SinglePromoRegisterPrompt
  },
  props: {
    classifiedId: { type: Number, default: () => null },
    classifieds: { type: Array, default: () => null },
    classifiedView: { type: Boolean, default: false },
    title: { type: String, default: null },
    withoutLabel: { type: Boolean, default: false },
    okOnly: { type: Boolean, default: false },
    hasActiveSchedule: { type: Boolean, default: false },
    infoMsg: { type: String, default: null }
  },
  data() {
    return {
      isLoading: true,
      isInfoModalVisible: false,
      hasAutoTouchPermission: false,
      viewTable: false,
      schedulerData: {
        schedule: {},
        selectedAvailability: {}
      },
      copySchedulerData: {
        schedule: {},
        selectedAvailability: {}
      }
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userType: 'type'
    }),
    ...mapGetters(USER_NS, {
      paidCredits: 'paidCredits',
      isAdmin: 'isAdmin',
      isSingleOrAnon: 'isSingleOrAnon',
      userHasPermission: 'hasPermission'
    }),
    userCanSeeOneClickAutoTouchButton() {
      return this.userHasPermission(AccessToggleName.ONE_CLICK_AUTO_TOUCH)
    },
    currentDayCellVariantIndex() {
      if (this.currentDayNumber === 0) {
        return 6
      } else {
        return this.currentDayNumber - 1
      }
    },
    okTitle() {
      const translation = this.$i18n.t('save preferences')
      if (this.selectedDaysAndHours.length > 0) {
        return translation.replace(
          ' ',
          ` (${this.selectedDaysAndHours.length}) `
        )
      }
      return translation
    },
    autoTouchService() {
      return this.$dep(AutoTouchService)
    },
    snackbarService() {
      return this.$dep(SnackbarService)
    },
    days(): Array<{ key: string; label: TranslateResult; class?: string }> {
      return [
        { key: 'monday', label: this.$i18n.t('monday') },
        { key: 'tuesday', label: this.$i18n.t('tuesday') },
        { key: 'wednesday', label: this.$i18n.t('wednesday') },
        { key: 'thursday', label: this.$i18n.t('thursday') },
        { key: 'friday', label: this.$i18n.t('friday') },
        { key: 'saturday', label: this.$i18n.t('saturday') },
        { key: 'sunday', label: this.$i18n.t('sunday') }
      ]
    },
    selectedDaysAndHours(): Array<AutoTouchAvailability> {
      if (!this.copySchedulerData?.availability) {
        return []
      }
      const selectedDaysAndHours = []
      this.copySchedulerData.availability.forEach(a => {
        this.days.forEach(day => {
          if (a[day.key].isSelected) {
            selectedDaysAndHours.push(a[day.key])
          }
        })
      })

      return selectedDaysAndHours
    },
    currentDayNumber(): number {
      return new Date().getDay()
    },
    costCount(): number {
      if (this.selectedDaysAndHours.length) {
        return this.selectedDaysAndHours
          .map(s => s.cost)
          .reduce((a, c) => a + c)
      }
      return 0
    },
    totalWeeklyCost(): number {
      return (
        this.costCount +
        (this.copySchedulerData.totalCostForAllClassifieds || 0)
      )
    },
    touchedCount(): number {
      if (this.copySchedulerData?.schedule?.touchedCount >= 0) {
        return this.copySchedulerData.schedule.touchedCount
      }
      return null
    },
    icons(): object {
      return {
        renew: ciRotate,
        info: ciExclamationCircle,
        calendar: ciCalendar,
        back: ciAngleLeft
      }
    },
    modalSize() {
      if (this.isSingleOrAnon) {
        return 'md'
      } else if (!this.viewTable && this.userCanSeeOneClickAutoTouchButton) {
        return 'lg'
      }

      return 'xl'
    },
    expires(): string {
      if (this.copySchedulerData && this.copySchedulerData?.schedule?.expires) {
        return this.copySchedulerData.schedule.expires
      }
      return null
    },
    hasDataChanged(): boolean {
      return (
        JSON.stringify(this.schedulerData) !==
        JSON.stringify(this.copySchedulerData)
      )
    },

    remainingCredits(): number {
      return this.paidCredits - this.totalWeeklyCost
    },
    renewalUrl(): string {
      if (
        this.userType === UserType.MANAGER ||
        this.userType === UserType.DEALER ||
        this.userType !== this.isSingleOrAnon
      ) {
        return this.$router.resolve({
          name: '__account_credits'
        }).href
      }
      return null
    },
    fields() {
      const days = this.days.map(d => ({
        ...d,
        thClass: `!tw-bg-primary !tw-border-primary !tw-bg-primary !tw-border-primary ${
          this.withoutLabel ? '!tw-text-center' : ''
        }`
      }))
      return [
        {
          key: 'formatedHour',
          label: this.$i18n.t('hours'),
          thClass: `!tw-bg-primary !tw-border-primary ${
            this.withoutLabel ? '!tw-text-center' : ''
          }`
        },
        ...days
      ]
    },
    infoText(): Array<{ t: string; clickable?: string; button?: boolean }> {
      return [
        {
          t: this.$i18n.t(
            "with the 'renewal scheduler' tool you can schedule in advance your weekly 'renewals'."
          )
        },
        {
          t: this.$i18n.t(
            'each classified renewal will take place at the specific time you place on the calendar.'
          )
        },
        {
          t: this.$i18n.t('paid_credit_service')
        },
        {
          t: this.$i18n.t('you can buy credits whenever you want from'),
          clickable: 'redirect'
        },
        {
          t: this.$i18n.t(
            "your classifieds will appear first in the search results for the time you chose at the 'renewal scheduler'."
          )
        },
        {
          t: this.$i18n.t(
            'during the week you can edit or cancel your choices.'
          )
        },
        {
          t: this.$i18n.t('schedule_duration')
        },
        {
          t: this.$i18n.t('stop_auto_renewal')
        },
        {
          t: this.$i18n.t(
            "you can have the same choices for the next week as well by pressing the 'refresh button'"
          ),
          button: true
        },
        {
          t: this.$i18n.t(
            'you will be charged at the specific time you choose for each renewal.'
          )
        },
        {
          t: this.$i18n.t(
            'the cost varies during the time you choose on the calendar and you could know in advance the total cost of your renewals.'
          )
        },
        {
          t: `${this.$i18n.t(
            "if you don't have the required credit balance you can even schedule your renewals with the tool."
          )} ${this.$i18n.t(
            'this is happening because you will be charged at the time of the renewal.'
          )}`
        },
        {
          t: this.$i18n.t('start saving time now!'),
          clickable: 'closeModal'
        }
      ]
    },
    hasPreviousSchedules(): boolean {
      return (
        this.copySchedulerData.previousSchedules &&
        Object.keys(this.copySchedulerData.previousSchedules)?.length > 0
      )
    },
    isMassRenewal() {
      return this.classifieds?.length
    },
    formatedExpires() {
      return format(this.expires, 'dd/MM/yy HH:mm:ss')
    }
  },
  created() {
    if (this.isMassRenewal) {
      this.isLoading = false
      vue3Set(
        this.copySchedulerData,
        'availability',
        this.autoTouchService.getAvailabilityForMassAcions()
      )
      this.syncData()
    } else {
      this.fetchAutoTouchScheduler()
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setAutoTouchDataInSearch: SET_AUTO_TOUCH_DATA_IN_SEARCH
    }),
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setAutoTouchDataInView: SET_AUTO_TOUCH_DATA_IN_VIEW
    }),
    updateScheduler() {
      this.autoTouchService.updateScheduler(this.classifiedId)
    },

    handleCheckboxChange({
      checkboxStatus,
      hour,
      date
    }: {
      checkboxStatus: boolean
      hour: string
      date: string
    }) {
      const selectedAvailability = this.copySchedulerData.availability.find(
        a => a[date].hour === hour
      )
      selectedAvailability[date].isSelected = checkboxStatus
    },
    handleSubmit(e) {
      e.preventDefault()
      const scheduleData = this.selectedDaysAndHours.map(dh => ({
        hour: dh.hour,
        day: dh.date
      }))
      if (this.selectedDaysAndHours.length) {
        if (this.isMassRenewal) {
          this.massScheduleAutoTouch(scheduleData)
        } else {
          this.scheduleAutoTouch(scheduleData)
        }
      } else {
        this.clearSchedule()
      }
    },
    syncData() {
      this.schedulerData = deepJsonCopy(this.copySchedulerData)
    },
    handleRevert(e) {
      e.preventDefault()

      this.copySchedulerData = deepJsonCopy(this.schedulerData)
    },
    clearAllSelected() {
      this.selectedDaysAndHours.forEach(sDay => {
        this.copySchedulerData.availability.forEach(a => {
          if (a[sDay.date] && a[sDay.date].hour === sDay.hour) {
            a[sDay.date].isSelected = false
          }
        })
      })

      this.updateScheduleData(null, null)
    },
    handleSelectAll() {
      this.copySchedulerData.availability.forEach(data => {
        this.days.forEach(day => {
          data[day.key].isSelected = true
        })
      })

      this.updateScheduleData(null, null)
    },
    updateScheduleData(touchedCount: number, expires: string) {
      const schedule = {
        ...this.copySchedulerData.schedule,
        touchedCount,
        expires
      }
      vue3Set(this.copySchedulerData, 'schedule', schedule)
    },
    setPreviousSchedule() {
      this.clearAllSelected()
      const { previousSchedules } = this.copySchedulerData
      previousSchedules.forEach(ps => {
        this.copySchedulerData.availability.forEach(a => {
          if (a[ps.day] && a[ps.day].hour === ps.hour) {
            a[ps.day].isSelected = true
          }
        })
      })

      this.updateScheduleData(null, null)
    },
    async handleRenew() {
      this.isLoading = true
      try {
        const {
          touchedCount,
          expires
        } = await this.autoTouchService.renewExpire(this.classifiedId)
        this.updateScheduleData(touchedCount, expires)
        this.syncData()
        if (this.classifiedView) {
          this.setAutoTouchDataInView({ touchedCount, expires })
        } else {
          this.setAutoTouchDataInSearch({
            classifiedId: this.classifiedId,
            autoTouchData: { touchedCount, expires }
          })
        }
        this.snackbarService.success(this.$i18n.t('successful renewal'))
      } catch (error) {
        handleError(error, this.$snackbar, this.$logger, this.$t.bind(this))
      } finally {
        this.isLoading = false
      }
    },
    async clearSchedule() {
      try {
        this.isLoading = true
        await this.autoTouchService.deleteSchedule(this.classifiedId)
        this.copySchedulerData.schedule = {}
        if (this.classifiedView) {
          this.setAutoTouchDataInView(null)
        } else {
          this.setAutoTouchDataInSearch({
            classifiedId: this.classifiedId,
            autoTouchData: null
          })
        }
        this.syncData()
        this.snackbarService.success(this.$i18n.t('updated successfully'))
      } catch (error) {
        handleError(error, this.$snackbar, this.$logger, this.$t.bind(this))
      } finally {
        this.isLoading = false
      }
    },
    async fetchAutoTouchScheduler() {
      if (this.isSingleOrAnon) {
        return
      }
      try {
        this.isLoading = true
        this.copySchedulerData = await this.autoTouchService.fetchAutoTouchScheduler(
          this.classifiedId
        )
        this.hasAutoTouchPermission = true
        this.syncData()
      } catch (error) {
        if (error.response.status === HttpStatus.UNAUTHORIZED) {
          this.hasAutoTouchPermission = false
        }
        handleError(error, this.$snackbar, this.$logger, this.$t.bind(this))
      } finally {
        this.isLoading = false
      }
    },

    async massScheduleAutoTouch(scheduleData: []) {
      try {
        this.isLoading = true
        const res = await this.autoTouchService.massScheduleAutoTouch(
          this.classifieds,
          scheduleData
        )
        this.classifieds.forEach(c => {
          this.setAutoTouchDataInSearch({
            classifiedId: c,
            autoTouchData: res
          })
        })
        this.snackbarService.success(
          this.$i18n.t('the schedule renewal created successfuly')
        )
      } catch (error) {
        handleError(error, this.$snackbar, this.$logger, this.$t.bind(this))
      } finally {
        this.isLoading = false
      }
    },

    async scheduleAutoTouch(
      scheduleData: Array<{ day: string; hour: string }>
    ) {
      try {
        this.isLoading = true
        const res = await this.autoTouchService.scheduleAutoTouch(
          this.classifiedId,
          scheduleData
        )
        if (this.classifiedView) {
          this.setAutoTouchDataInView(res)
        } else {
          this.setAutoTouchDataInSearch({
            classifiedId: this.classifiedId,
            autoTouchData: res
          })
        }
        const { touchedCount, expires } = res
        this.updateScheduleData(touchedCount, expires)
        this.syncData()
        this.snackbarService.success(
          this.$i18n.t('preferences saved successfully')
        )
      } catch (error) {
        handleError(error, this.$snackbar, this.$logger, this.$t.bind(this))
      } finally {
        this.isLoading = false
      }
    }
  },
  i18n: defineComponentTranslations({
    schedule_table: {
      en: 'Schedule table',
      el: 'Πίνακας προγραμματισμού'
    },
    schedule_renewals: {
      en: 'Schedule renewals hourly/daily',
      el: 'Προγραμμάτισε ανανεώσεις ανά ώρα/ημέρα'
    },
    schedule_duration: {
      en:
        'The schedule is active as long as the credits are sufficient and the ad is active.',
      el:
        'Ο προγραμματισμός ισχύει για όσο επαρκούν τα credits και η αγγελία είναι ενεργή.'
    },
    stop_auto_renewal: {
      en:
        'If you want to stop the auto renewal, please fix the selected hours.',
      el:
        'Αν θέλεις να διακόψεις την αυτόματη ανανέωση κάνε καθαρισμό των επιλεγμένων ωρών.'
    },
    'during the week you can edit or cancel your choices.': {
      en: 'During the week you can edit or cancel your choices.',
      el:
        'Μπορείτε κατά τη διάρκεια της εβδομάδας να αλλάξετε τον προγραμματισμό ή να ακυρώσετε τελείως όλες τις προγραμματισμένες ανανεώσεις.'
    },
    "with the 'renewal scheduler' tool you can schedule in advance your weekly 'renewals'.": {
      en:
        "With the 'renewal scheduler' tool you can schedule in advance your weekly 'renewals'.",
      el:
        'Με τον προγραμματισμό ανανεώσεων μπορείτε να προγραμματίσετε εκ των προτέρων τις εβδομαδιαίες ανανεώσεις σας.'
    },
    'each classified renewal will take place at the specific time you place on the calendar.': {
      en:
        'Each classified renewal will take place at the specific time you place on the calendar.',
      el: 'Η ανανέωση γίνεται την ώρα που εσείς θα ορίσετε.'
    },
    paid_credit_service: {
      en: 'This service can only be used with paid credits',
      el: 'Η υπηρεσία αυτή υποστηρίζεται μόνο με πληρωμένα credits'
    },
    "your classifieds will appear first in the search results for the time you chose at the 'renewal scheduler'.": {
      en:
        "Your classifieds will appear first in the search results for the time you chose at the 'renewal scheduler'.",
      el:
        'Οι αγγελίες σας βγαίνουν πρώτες στα αποτελέσματα αναζήτησης για τη συγκεκριμένη χρονική στιγμή χωρίς να απαιτείται κάποια επιπλέον ενέργεια.'
    },
    "you can have the same choices for the next week as well by pressing the 'refresh button'": {
      en:
        "You can have the same choices for the next week as well by pressing the 'refresh button'",
      el:
        "Μπορείτε να ανανεώσετε το πλάνο και για την επόμενη εβδομάδα πατώντας το 'κουμπί ανανέωσης'"
    },
    'you will be charged at the specific time you choose for each renewal.': {
      en:
        'You will be charged at the specific time you choose for each renewal.',
      el:
        'Η χρέωση των credits γίνεται την ώρα που γίνεται η ανανέωση και όχι όταν δημιουργείτε το πλάνο προγραμματισμού.'
    },
    'the cost varies during the time you choose on the calendar and you could know in advance the total cost of your renewals.': {
      en:
        'The cost varies during the time you choose on the calendar and you could know in advance the total cost of your renewals.',
      el:
        'Το κόστος μεταβάλλεται ανάλογα με την ώρα προγραμματισμού της κάθε ανανέωσης και έτσι μπορείτε να γνωρίζετε εκ των προτέρων το κόστος ανανέωσης των αγγελιών σας.'
    },
    "if you don't have the required credit balance you can even schedule your renewals with the tool.": {
      en:
        "If you don't have the required credit balance you can even schedule your renewals with the tool.",
      el:
        'Μπορείτε ακόμη και εάν δε διαθέτετε το απαιτούμενο υπόλοιπο σε credits τη συγκεκριμένη χρονική στιγμή να προγραμματίζετε τις ανανεώσεις σας.'
    },
    'you can buy credits whenever you want from': {
      en: 'You can buy credits whenever you want from',
      el: 'Μπορείτε να αγοράσετε credits όποτε επιθυμείτε'
    },
    'start saving time now!': {
      en: 'Start saving time now!',
      el: 'Κερδίστε χρόνο τώρα!'
    }
  })
})
